module.exports = __webpack_public_path__ + "img/card-bg-02.510b5b22.png";